export default __webpack_public_path__ + "fonts/ai-star-icon.svg";